import React, { Component } from 'react';
import { WithStyles, createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import AudioProgressBar from './../AudioCreate/AudioProgressBar';
import AudioUploadDialog from './../AudioCreate/AudioUploadDialog';
import { MyPATDialog } from '../../../../common';
import contentService from '../../../services/contentService';
import audioUploadService from '../../../services/audioService';
import { audioActions } from '../../../reducers/audioCreateContentReducers';
import { showMsg } from '../../../../course/actions/loaderAlert';
import { AUDIO_UPLOAD_MODES } from '../../../../../constants/comman';
import axios from "axios";
import { getKeyFromStreamUrlAudio } from '../../../../../utils';
import * as JSLZString from 'lz-string';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { audioDetailsActions } from '../../../reducers/audioDetailsReducer';
import * as focusedSectionActions from "../../../../../components/common/actions/focusedSectionAction";

const styles = (theme: Theme) => createStyles({});
const fileLength = 524288000;

interface StudyAudioCreateProps extends WithStyles<typeof styles> {
    dialogOpen: boolean;
    onDialogClose: Function;
    audioUploadModal: boolean;
    isAudioUrlUploadModal: boolean;
    changeAudioUploadProgressPercentage: Function;
    addAudioDetails: Function;
    handleURL: Function;
    showMsg: Function;
    openAudioModal: Function;
    resetAudioModalState: Function;
    setAudioDetailsData: Function;
    mode: string;
    submitAudio: Function;
    audioId?: any;
    history:any;
    focusSection: Function;
}

interface StudyAudioCreateState {}
const url = 'https://mypat-v2-staging.s3.us-west-2.amazonaws.com/audios/audio-img.svg';

class StudyAudioCreate extends Component<StudyAudioCreateProps, StudyAudioCreateState> {
    constructor(props: StudyAudioCreateProps) {
        super(props);
        this.state = {
        }
    }
    uploadAudio = (file: any = {}) => {
        const source = axios.CancelToken.source();
        const supportedAudioFormats =['wav', 'mpeg'];
        const currentFileFormat = file.type.split('/').pop();
        const { changeAudioUploadProgressPercentage, addAudioDetails, handleURL, showMsg, openAudioModal, audioId } = this.props;
        if (file.length > fileLength) {
            showMsg('Please upload a audio of size less than 500 MB', 'error');
            return;
        } else if (!supportedAudioFormats.includes(currentFileFormat)) {
            showMsg('Only .mp3 and .wav files are supported', 'error');
            return;
        }
        openAudioModal();
        addAudioDetails({
            file: file,
            name: file.name || '',
            length: file.size || 0,
            type: file.type || '',
            source
        });
        changeAudioUploadProgressPercentage(0);

        //upload and hange state
        audioUploadService.uploadAudio(file, (event: any) => {
            changeAudioUploadProgressPercentage(Math.round((100 * event.loaded) / event.total));
        }, source.token, audioId)
            .then((response) => {
                handleURL(response);
            })
            .catch((err: any) => {
                if (axios.isCancel(err)) {
                    showMsg('Audio upload has been cancelled', 'error');
                }
                this.props.resetAudioModalState();
            })
    }

    createAudioSubmit = (audioUrl: string, fromPage?: boolean) => {
        const audioKey = audioUrl;
        const thumbnailUrl = url;
        let saveRequest: any = {
            audioUrl: audioKey,
            completionPercent: 25,
            thumbnailUrl,
            _id: this.props.audioId
        }

        contentService.save('', 'audios', saveRequest, false, '', 'put').then((result: any) => {
            const {
                responseObject: {
                    audio: { _id } = {}
                }
            }: {
                responseObject: {
                    audio: {
                        _id?: string
                    }
                }
            } = result;
            if (_id) {
                contentService.detailsNTL(_id + 'audios').then((res: any) => {
                    this.props.focusSection('');
                    this.props.submitAudio(res)
                })
            }
        })        
    }

    createAudioContent = async (audioUrl: string, fromPage?: boolean) => {
        const audioKey = audioUrl;
        const thumbnailUrl = url;
        let saveRequest: any = {
            audioUrl: audioKey,
            completionPercent: 25,
            thumbnailUrl
        }

        contentService.save('', 'audios', saveRequest, false).then((result: any) => {
            const {
                responseObject: {
                    audio: { _id } = {}
                }
            }: {
                responseObject: {
                    audio: {
                        _id?: string
                    }
                }
            } = result;
            if (_id) {
                this.props.onDialogClose()
                window.open(`/content/edit/studymaterial/audios/${_id}audios`, '_blank')
            }
        })
    }

    deleteAudio = (audioUrl: any) => {
        audioUploadService.deleteAudioService({ audioUrl }).then(async (resData: any) => {
            if (resData.statusCode === 200) {
                this.props.resetAudioModalState();
            } else {
                this.props.showMsg('Unable to delete Audio', 'error');
            }
        }).catch(() => {
            this.props.showMsg('Unable to delete Audio', 'error');
        });
    }

    removeFocus = () => {
        this.props.focusSection('');
    }

    render() {
        const { dialogOpen, onDialogClose, audioUploadModal, mode, submitAudio, audioId } = this.props;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'sm',
            scroll: 'body',
        };
        return (
            <>
                {mode !== AUDIO_UPLOAD_MODES.EDIT ? 
                <MyPATDialog
                    dialogHeading="Insert Audio"
                    dialogOpen={dialogOpen}
                    dialogHasActions={false}
                    customButtonVariant="withoutBorderCloseIcon"
                    onDialogClose={onDialogClose}
                    isAlignCenter={true}
                    otherDialogProps={otherDialogProps}
                >
                    {
                        audioUploadModal ? <AudioProgressBar onDialogClose={onDialogClose} createAudioContent={this.createAudioContent} deleteAudio={this.deleteAudio} removeFocus={this.removeFocus}/> 
                        : <AudioUploadDialog onDialogClose={onDialogClose} uploadAudio={this.uploadAudio} />
                        
                    }
                </MyPATDialog>
                
                 :audioUploadModal ? <AudioProgressBar mode={AUDIO_UPLOAD_MODES.EDIT} onDialogClose={onDialogClose} createAudioContent={this.createAudioSubmit} deleteAudio={this.deleteAudio} removeFocus={this.removeFocus}/> 
                 : <AudioUploadDialog mode={AUDIO_UPLOAD_MODES.EDIT} onDialogClose={onDialogClose} uploadAudio={this.uploadAudio} />
                }

            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        audioUploadModal: _.get(state, 'audioCreateContent.audioUploadModal', false),
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    handleURL: audioActions.audioUrlChanged,
    changeAudioUploadProgressPercentage: audioActions.changeAudioUploadProgressPercentage,
    addAudioDetails: audioActions.addAudioDetails,
    showMsg: showMsg,
    openAudioModal: audioActions.openAudioModal,
    resetAudioModalState: audioActions.resetAudioModalState,
    setAudioDetailsData :audioDetailsActions.addAudioDetails,
    focusSection: focusedSectionActions.focusSection,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(StudyAudioCreate)));